import React from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { formatFunctions } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import '../../assets/styles/components/order/order-cancel.scss';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP , Icons} from '@/configurations';
import { getSafe } from '@/helpers/global'
import '@/assets/styles/components/order-confirm-status.scss';

const riskDisclosureHrefs = window?.config?.companyOptions?.riskDisclosure
const importantNoticeHrefs = window?.config?.companyOptions?.importantNotice
class OrderCancelMobile extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          data:[],
          orderData:[],
          load:false
        }
    }

    handleCancelData = () => {
        const {language, order} = this.props;
        let bs = '';
        const orderType = order.orderType.value || order.orderType;
        if(order.bs){
            bs = order.bs
        } else {
            const isBuy = this.props.isBuy;
            if(isBuy === true){
                bs = 'B'
            } else {
                bs = 'S'
            }
        }
        let data = []
        if(order.marketID !== 'FUND'){
            data = [
                { label: language.common_order_id, value: order.orderGroupID },
                {
                    label: language.common_order_direction,
                    value: bs === 'B' ? language.common_buy : language.common_sell,
                    classStyle: [`order-direction-${bs.toLowerCase()}`]
                },
                { label: language.common_order_type, value: language[`order_type_${orderType.toLowerCase()}`] },
                { label: language.common_symbol, value: `${order.marketID}.${order.instrumentID}` },
                { label: language.common_name, value: this.mapStockName(order) ?  this.mapStockName(order) : '-' },
                {
                    label: language.common_price,
                    value: order.price ? `${order.currencyID} ${formatFunctions.dataFormat(order.price, dataType.CURRENCY)}` : '-'
                },
                {
                    label: language.common_stop_type,
                    value: getSafe(() => language[`order_stop_price_type_${order.stopOrderType}`], '-')
                },
                {
                    label: language.common_stop_price,
                    value: order.stopPrice ? `${order.currencyID} ${formatFunctions.dataFormat(order.stopPrice, dataType.CASH)}` : '-'
                },
                {
                    label: language.common_quantity,
                    value: this.handleQuantityText(order.qty)
                },
                {
                    label: language.common_good_till_date,
                    value: order.goodTillDate ? formatFunctions.dataFormat(order.goodTillDate, dataType.SHORT_DATE) : '-'
                },
                {
                    label: language.common_commission_fees,
                    value: (order.grossAmt && order.netAmt) ? `${order.currencyID} ${formatFunctions.dataFormat(Math.abs(order.netAmt - order.grossAmt), dataType.CASH)}` : '-'
                }
            ]
        } else {
            data = [
                { label: language.common_order_id, value: order.orderGroupID },
                {
                    label: language.common_order_direction,
                    value: bs === 'B' ? language.common_funds_subscription : language.common_funds_redemption,
                    classStyle: [`order-direction-${bs.toLowerCase()}`]
                },
                { label: language.common_funds_market_id, value: 'FUND' },
                { label: language.funds_instrument_id, value: order.instrumentID},
                { label: language.funds_instrument_name, value: order.instrumentName},
                {
                    label: language.common_price,
                    value: order.price ? `${order.currencyID} ${formatFunctions.dataFormat(order.price, dataType.CURRENCY)}` : '-'
                },
                {
                    label: language.common_quantity,
                    value: this.handleQuantityText(order.qty)
                },
                {
                    label: language.common_good_till_date,
                    value: order.goodTillDate ? formatFunctions.dataFormat(order.goodTillDate, dataType.SHORT_DATE) : '-'
                }
            ]
        }
        // if(order.marketID !== 'FUND'){
        //     data.push({
        //         label: language.common_commission_fees,
        //         value: (order.grossAmt && order.netAmt) ? `${order.currencyID} ${formatFunctions.dataFormat(Math.abs(order.netAmt - order.grossAmt), dataType.CASH)}` : '-'
        //     })
        // }
        this.setState({
            data: data
        })
    }

    handleQuantityText(value) {
        const { language } = this.props;
        let text = '-';
        if (value !== null) {
          text = `${formatFunctions.dataFormat(value, dataType.NUMBER)} ${language.common_share.format((language.lang === 'en_US' && value > 1) ? 's' : '')}`
        }
        return text;
      }

    mapStockName(order){
        const { language } = this.props
        let stockName = '' 
        if(language.title === 'zh_TW' || language.title === 'zh_CN'){
            if(order.instrumentChineseName){
            stockName = order.instrumentChineseName
            }else{
            stockName = order.instrumentName
            }
        }else{
            stockName = order.instrumentName
        }
        return stockName
    }

    handleConfirm = () => {
        if(this.state.load) return
        this.setState({load:true})
        const { language, order, currentTradingAccount } = this.props;
        const params = {
          [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
          [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
          [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq + '',
          [PARAMS.LANGUAGE]: language.lang,
          [PARAMS.ORDER_GROUP_ID]: order.orderGroupID,
          [PARAMS.ORDER_ID]: order.orderID
        }
        this.props.cancelOrder(params, res => {
          if (res.status === SERVICES_RESP.STATUS_OK) {
            const orderResult = {
              ...this.props.order,
              ...res.result,
              isSuccess: res.result.isSuccess,
              orderID: this.props.order.orderID,
              inputTime: this.props.order.inputTime,
              quantity: this.props.order.qty
            }
            this.setState({load:false},()=>{
                this.props.cb(orderResult,order);
            })
          }else{
              this.setState({load:false})
          }
        })
      }

    getDate = () => {
        const { currentTradingAccount, language, order } = this.props
        if (currentTradingAccount.clientID) {
            const params = {
                [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
                [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
                [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
                [PARAMS.ORDER_GROUP_ID]: order.orderGroupID,
                [PARAMS.LANGUAGE]: language.lang
            }
            this.props.getOrderDetail(params, res => {
                if (res.status === SERVICES_RESP.STATUS_OK) {
                    if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
                        const orderData = res.result.orderInfoList.length > 0 ? res.result.orderInfoList[0] : order;
                        this.setState({ orderData: orderData });
                    }
                }
                this.setState({ loading: true, isLoading: false })
            })
        }
    }

    componentDidMount(){
        this.handleCancelData();
    }

    onClose = () => {
        this.props.closeLayout();
    }

    render(){
        const {language, order} = this.props
        const {data, load} = this.state
        return(
            <div className='order-cancel-mobile-container'>
                <div className='order-remind'>
                    <span>{language.order_cancel_remind}</span>
                </div>
                <div className='order-container'>
                    {data.map(item => 
                        <div className='order-container-item' key={item.label}>
                            <span>{item.label}</span>
                            <span className={classnames('value', getSafe(() => item.classStyle.join(' '), ''))}>{item.value}</span>
                        </div>
                    )}
                </div>
                <div className='order-gross'>
                    <span>{language.common_gross_amount}</span>
                    <span>{order.netAmt ? `${order.currencyID} ${formatFunctions.dataFormat(order.netAmt, dataType.CASH)}`
                        : `${order.currencyID} ${formatFunctions.dataFormat(order.price * order.qty, dataType.CASH)}`}</span>
                </div>
                <div className='order-button'>
                    {/* <div className='read-content'>
                        <span>{language.common_please_read} </span>
                        <a target='_blank' href={riskDisclosureHrefs?.[language.lang] || '#'}>
                            {language.common_the_risk_disclosure}
                        </a>
                        <span> {language.common_and} </span>
                        <a target='_blank' href={importantNoticeHrefs?.[language.lang] || '#'}>
                            {language.common_important_statement}
                        </a>
                    </div> */}
                    <div className='button-content'>
                        <button className='button-cancel' onClick={() => this.onClose()}>{language.common_cancel}</button>
                        <button className='button-confirm' onClick={() => this.handleConfirm()}>
                            {load ? <Icons.Loading/> : language.common_confirm}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
export default connect(
    state => ({
      language: state.app.language,
      currentTradingAccount: state.trade.currentTradingAccount
    }),
    dispatch => ({
        getOrderDetail: (p, c) => dispatch(orderActions.getOrderDetailAction(p, c)),
        cancelOrder: (p, res) => dispatch(orderActions.cancelOrderAction(p, res))
    })
)(OrderCancelMobile)